// extracted by mini-css-extract-plugin
export default {"heading":"FormHeading__heading___24dT0"};